import MenuIcon from '../../menus/model/MenuIcon';
import ProjectFormationSectionTranslations from './ProjectFormationSectionTranslations';
import ProjectsNumberDescComponent from './ProjectsNumberDescComponent';
export default class ProjectFormationSection {
    constructor(projects) {
        const { id, projects_number_desc_component, translations, section_image } = projects;
        this.id = id;
        this.section_image = section_image ? new MenuIcon(section_image) : undefined;
        this.projects_number_desc_component = projects_number_desc_component
            ? projects_number_desc_component.map(element => new ProjectsNumberDescComponent(element))
            : [];
        this.translations = translations
            ? translations.map(translation => new ProjectFormationSectionTranslations(translation))
            : [];
    }
}
